import { PagePending } from "@/components/ui/PagePending";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/user-settings")({
  pendingComponent: PagePending,
  component: lazyRouteComponent(() => import("./+UserSettings")),
  head: () => ({ meta: seo({ title: "Settings" }) }),
});
